// agentSkillsMap.js
// Maps each marketplace vertical to compatible skills

export const AGENT_SKILLS_MAP = {
  "customer-support": [
    { id: "atendimento", name: "Support", icon: "\uD83C\uDFA7", category: "Support", price: "Free", description: "Automatically answer tickets based on your knowledge base." },
    { id: "faq-dinamico", name: "Dynamic FAQ", icon: "\uD83C\uDFE2", category: "Support", price: "Free", description: "Smart FAQ that learns from every interaction." },
  ],
  "e-commerce": [
    { id: "gestao-pedidos", name: "Order Management", icon: "\uD83D\uDCE6", category: "Operations", price: "$19.90/month", description: "Track and manage orders automatically." },
    { id: "atendimento", name: "Support", icon: "\uD83C\uDFA7", category: "Support", price: "Free", description: "24/7 customer support via WhatsApp and Instagram." },
  ],
  "real-estate": [
    { id: "qualificacao-leads", name: "Lead Qualification", icon: "\uD83C\uDFE0", category: "Sales", price: "$29.90/month", description: "Qualifies leads automatically and schedules visits." },
    { id: "atendimento", name: "Support", icon: "\uD83C\uDFA7", category: "Support", price: "Free", description: "24/7 real estate support." },
  ],
  "consultancy": [
    { id: "agendamento", name: "Smart Scheduling", icon: "\uD83D\uDCC5", category: "Operations", price: "$19.90/month", description: "Automatically schedules meetings based on availability." },
    { id: "redacao-contratos", name: "Contract Drafting", icon: "⚖️", category: "Legal", price: "$29.90/month", description: "Automatically generates contracts based on scope." },
  ],
  "marketing-agencies": [
    { id: "rede-social", name: "Social Media Management", icon: "\uD83D\uDCF1", category: "Marketing", price: "$24.90/month", description: "Posts, replies to DMs, and monitors mentions automatically." },
    { id: "relatorios", name: "Automated Reports", icon: "\uD83D\uDCCA", category: "Analytics", price: "$19.90/month", description: "Automatically generates performance reports." },
  ],
};

export function getSkillsForAgent(agentSlug) {
  return AGENT_SKILLS_MAP[agentSlug] || [];
}
